import { Component, ViewEncapsulation } from '@angular/core';

@Component({
  selector: 'no-visitor-monitor-splash-screen',
  templateUrl: './no-visitor-monitor-splash-screen.component.html',
  styleUrls: ['./splash-screens.scss'],
  encapsulation: ViewEncapsulation.None
})
export class NoVisitorMonitorSplashScreenComponent {
}
